import { useEffect, useState } from "react";

const useAvailibleMenu = (routes, defaultPathValue = "/tracked_assets") => {
  const [data, setData] = useState({
    availableMenuPaths: {},
    allPaths: {},
    defaultPath: "",
  });

  const getPathMap = (r, isRoot) => {
    let availableMenuPathsList = [];
    let forceAvalibleMenuList = [];
    let allPaths = {};

    if (r.to) {
      if ((isRoot && r.view !== false) || (!isRoot && r.view)) {
        availableMenuPathsList.push({ key: r.to, value: r });
        // r.subPages?.forEach((sub) => {
        //   availableMenuPathsList.push({ key: sub, value: r });
        // });
      }
      if (r.isForceAvailableMenu) {
        forceAvalibleMenuList.push({ key: r.to, value: r });
      }
      allPaths[r.to] = r;
      r.subPages?.forEach((sub) => {
        allPaths[sub] = r;
        // if (sub === "factory_upload_update") {
        //   if (r.view) {
        //     availableMenuPathsList.push({ key: sub, value: r, isSubMenu: true });
        //   }
        // } else {
        //   availableMenuPathsList.push({ key: sub, value: r, isSubMenu: true });
        // }
        availableMenuPathsList.push({ key: sub, value: r, isSubMenu: true });
      });
    } else {
      r.views?.forEach((route) => {
        const {
          availableMenuPathsList: avaliable,
          forceAvalibleMenuList: forceList,
          allPaths: match,
        } = getPathMap(route, false);
        if ((isRoot && r.view !== false) || (!isRoot && r.view)) {
          availableMenuPathsList = [...availableMenuPathsList, ...avaliable];
        }
        forceAvalibleMenuList = [...forceAvalibleMenuList, ...forceList];
        allPaths = { ...allPaths, ...match };
      });
    }

    return {
      availableMenuPathsList: availableMenuPathsList,
      forceAvalibleMenuList: forceAvalibleMenuList,
      allPaths: allPaths,
    };
  };

  useEffect(() => {
    let allPaths = {};
    let availableMenuPathsList = [];
    let forceAvalibleMenuList = [];
    routes?.forEach((r) => {
      const {
        availableMenuPathsList: avaliable,
        forceAvalibleMenuList: forceList,
        allPaths: match,
      } = getPathMap(r, true);
      availableMenuPathsList = [...availableMenuPathsList, ...avaliable];
      forceAvalibleMenuList = [...forceAvalibleMenuList, ...forceList];
      allPaths = { ...allPaths, ...match };
    });

    let availableMenuPaths = {};
    availableMenuPathsList.forEach((item) => {
      availableMenuPaths[item.key] = item.value;
    });

    let forceMenuPaths = {};
    forceAvalibleMenuList.forEach((item) => {
      forceMenuPaths[item.key] = item.value;
    });

    let filterListMenu = availableMenuPathsList?.filter(
      (item) => !item.isSubMenu
    );

    let path = defaultPathValue;
    if (!availableMenuPaths[defaultPathValue] && filterListMenu.length > 0) {
      // use first path
      path = filterListMenu[0].key;
    }

    setData({
      routes,
      availableMenuPaths,
      forceMenuPaths,
      allPaths,
      defaultPath: {
        pathname: path,
        search: "",
      },
      isAdminMenuAvailable: filterListMenu.length > 0,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [routes]);

  return data;
};

export default useAvailibleMenu;
